import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DoubleBorderButtonComponent} from './components/double-border-button/double-border-button.component';
import {ButtonComponent} from './components/button/button.component';
import {GradientButtonComponent} from './components/gradient-button/gradient-button.component';
import {YoutubePlayerComponent} from './components/youtube-player/youtube-player.component';
import {SafePipe} from './pipes/safe.pipe';
import {MarkdownModule} from 'ngx-markdown';
import {DoubleBorderHeaderComponent} from './components/double-border-header/double-border-header.component';
import {BackgroundStripeComponent} from './components/background-stripe/background-stripe.component';
import {CheckboxComponent} from './form/checkbox/checkbox.component';
import {TextInputComponent} from './form/text-input/text-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyTabsModule as MatTabsModule} from '@angular/material/legacy-tabs';
import {CircularImageLinkComponent} from './components/circular-image-link/circular-image-link.component';
import {CarouselComponent} from './components/carousel/carousel.component';
import {MatCarouselModule} from '@magloft/material-carousel';
import {DynamicContentComponent} from './components/dynamic-content/dynamic-content.component';
import {QuoteComponent} from './components/quote/quote.component';
import {ImageComponent} from './components/image/image.component';
import {NumberInputComponent} from './form/number-input/number-input.component';
import {ContactAndNieuwsbriefComponent} from './components/contact-and-nieuwsbrief/contact-and-nieuwsbrief.component';
import {ContactComponent} from './components/contact/components/contact/contact.component';
import {NieuwsbriefComponent} from './components/nieuwsbrief/components/nieuwsbrief/nieuwsbrief.component';
import {NieuwsbriefFormComponent} from './components/nieuwsbrief/components/nieuwsbrief-form/nieuwsbrief-form.component';
import {HorizontalScrollListComponent} from './components/horizontal-scroll-list/horizontal-scroll-list.component';
import {HoeOndersteunenComponent} from './components/hoe-ondersteunen/hoe-ondersteunen.component';
import {ConfirmDialogComponent} from './dialog/confirm-dialog/confirm-dialog.component';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {RegistrationInformationDialogComponent} from './dialog/registration-information-dialog/registration-information-dialog.component';
import {FaConfig, FaIconLibrary, FontAwesomeModule,} from '@fortawesome/angular-fontawesome';
import {MatLegacySnackBarModule as MatSnackBarModule} from '@angular/material/legacy-snack-bar';
import {
  faAnchor,
  faAt,
  faAward,
  faBallot,
  faBookHeart,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faChartLineDown,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChild,
  faComment,
  faComments,
  faCompass,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEuroSign,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faFingerprint,
  faGrinBeam,
  faHandHeart,
  faHandHoldingSeedling,
  faHandsHelping,
  faHeart as fasHeart,
  faHistory,
  faHouseDay,
  faIcons,
  faInfo,
  faLink,
  faMapMarkerAlt,
  faMapMarkerSmile,
  faMedal,
  faPaperPlane,
  faPen,
  faPeopleCarry,
  faPhone,
  faPlus,
  faPrint,
  faRunning,
  faSave,
  faSignOutAlt,
  faSpinner,
  faStamp,
  faSync,
  faTag,
  faTimes,
  faTrash,
  faUser,
  faUsers,
  faUsersClass,
  faUsersCog,
} from '@fortawesome/pro-solid-svg-icons';
import {faFacebookSquare, faLinkedin, faTwitter,} from '@fortawesome/free-brands-svg-icons';
import {NotificationComponent} from './notification/notification.component';
import {ZinActieComponent} from './components/zinanalyse/zin-actie/zin-actie.component';
import {SpinnerDialogComponent} from './dialog/spinner-dialog/spinner-dialog.component';
import {ScrollToDirective} from './directives/scroll-to.directive';
import {faHeart as farHeart} from '@fortawesome/pro-regular-svg-icons';
import {CapitalizeFirstLetterPipe} from './pipes/capitalize-first-letter.pipe';
import {HasGeslotenDeelDirective} from './directives/has-gesloten-deel.directive';
import {RequiresOneOfRolesDirective} from './directives/requires-one-of-roles.directive';
import {IsWarmeStedenDirective} from './directives/is-warme-steden.directive';
import {IsWarmeScholenDirective} from './directives/is-warme-scholen.directive';
import {TagCardViewComponent} from './tag/tag-card-view/tag-card-view.component';
import {TagsFilterComponent} from './tag/tags-filter/tags-filter.component';
import {MarkdownComponent} from './components/markdown/markdown.component';
import {PaginatorComponent} from './pagination/paginator/paginator.component';
import {BlueBoxComponent} from './components/blue-box/blue-box.component';
import {FilterTagComponent} from './components/filter-tag/filter-tag.component';
import {PrintButtonComponent} from './components/print-button/print-button.component';
import {NgxPrintModule} from 'ngx-print';

@NgModule({
  declarations: [
    DoubleBorderButtonComponent,
    ButtonComponent,
    GradientButtonComponent,
    YoutubePlayerComponent,
    DoubleBorderHeaderComponent,
    BackgroundStripeComponent,
    CheckboxComponent,
    TextInputComponent,
    CircularImageLinkComponent,
    CarouselComponent,
    DynamicContentComponent,
    QuoteComponent,
    ImageComponent,
    NumberInputComponent,
    ContactAndNieuwsbriefComponent,
    ContactComponent,
    NieuwsbriefComponent,
    NieuwsbriefFormComponent,
    HorizontalScrollListComponent,
    HoeOndersteunenComponent,
    ConfirmDialogComponent,
    RegistrationInformationDialogComponent,
    NotificationComponent,
    ZinActieComponent,
    SpinnerDialogComponent,
    ScrollToDirective,
    HasGeslotenDeelDirective,
    RequiresOneOfRolesDirective,
    IsWarmeStedenDirective,
    IsWarmeScholenDirective,
    CapitalizeFirstLetterPipe,
    SafePipe,
    TagCardViewComponent,
    TagsFilterComponent,
    MarkdownComponent,
    PaginatorComponent,
    BlueBoxComponent,
    FilterTagComponent,
    PrintButtonComponent,
  ],
  imports: [
    CommonModule,
    MarkdownModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    MatTabsModule,
    MatCarouselModule,
    MatDialogModule,
    MatSnackBarModule,
    FontAwesomeModule,
    NgxPrintModule
  ],
  exports: [
    DoubleBorderButtonComponent,
    ButtonComponent,
    GradientButtonComponent,
    YoutubePlayerComponent,
    DoubleBorderHeaderComponent,
    BackgroundStripeComponent,
    MarkdownComponent,
    CheckboxComponent,
    TextInputComponent,
    MatTabsModule,
    CircularImageLinkComponent,
    DynamicContentComponent,
    ImageComponent,
    NumberInputComponent,
    ContactAndNieuwsbriefComponent,
    ContactComponent,
    NieuwsbriefComponent,
    NieuwsbriefFormComponent,
    HorizontalScrollListComponent,
    HoeOndersteunenComponent,
    ConfirmDialogComponent,
    RegistrationInformationDialogComponent,
    FontAwesomeModule,
    ZinActieComponent,
    ScrollToDirective,
    CapitalizeFirstLetterPipe,
    CarouselComponent,
    ScrollToDirective,
    HasGeslotenDeelDirective,
    RequiresOneOfRolesDirective,
    IsWarmeStedenDirective,
    IsWarmeScholenDirective,
    TagCardViewComponent,
    TagsFilterComponent,
    MarkdownComponent,
    PaginatorComponent,
    BlueBoxComponent,
    FilterTagComponent,
    PrintButtonComponent,
  ],
})
export class SharedModule {
  constructor(library: FaIconLibrary, faConfig: FaConfig) {
    faConfig.fixedWidth = true;
    library.addIcons(
      fasHeart,
      farHeart,
      faLink,
      faFacebookSquare,
      faLinkedin,
      faTwitter,
      faTimes,
      faAt,
      faCaretDown,
      faSignOutAlt,
      faChartLineDown,
      faComment,
      faCalendar,
      faMapMarkerAlt,
      faUsers,
      faEuroSign,
      faExclamationTriangle,
      faInfo,
      faCalendarAlt,
      faPen,
      faPhone,
      faPaperPlane,
      faEnvelope,
      faChevronLeft,
      faChevronRight,
      faChevronDown,
      faChevronUp,
      faEye,
      faFingerprint,
      faUser,
      faUsersClass,
      faUsersCog,
      faBookHeart,
      faStamp,
      faAward,
      faHandHoldingSeedling,
      faGrinBeam,
      faHandsHelping,
      faHistory,
      faComments,
      faEdit,
      faMedal,
      faEllipsisV,
      faPlus,
      faSync,
      faSpinner,
      faTag,
      faSave,
      faTrash,
      faPeopleCarry,
      faBallot,
      faCompass,
      faAnchor,
      faChild,
      faHouseDay,
      faIcons,
      faMapMarkerSmile,
      faRunning,
      faHandHeart,
      faExclamation,
      faDownload,
      faPrint
    );
  }
}
